import React, { useRef } from "react";
import moment from "moment";
import {
  IonItem,
  IonDatetime,
  IonLabel,
  IonButton,
  IonText,
  IonContent,
  IonButtons,
  IonInput,
  useIonModal,
} from "@ionic/react";
import { Controller } from "react-hook-form";
import { useController } from "react-hook-form";
import { useIntl } from "react-intl";
import SkeltonItemContent from "./SkeltonItemContent";

const DateTimePicker = (props) => {
  const {
    name,
    control,
    label,
    disabled,
    type,
    presentation,
    loading,
    extraDetail,
    extraDetailColor,
    isDateEnabled,
    rules,
    required,
  } = props;
  const customDatetime = useRef();

  const intl = useIntl();
  const confirm = () => {
    if (customDatetime === undefined) return;
    handleDismiss();
    customDatetime.current.confirm();
  };

  const {
    field: { onChange, onBlur, value, ref },
  } = useController({
    name,
    control,
    rules: { required: !!required },
  });

  const handleDismiss = () => {
    dismiss();
  };

  const [present, dismiss] = useIonModal(
    <IonContent force-overscroll="false">
      <IonText>
        <h5 style={{ padding: "0 16px" }}>{label}</h5>
      </IonText>
      <IonDatetime
        isDateEnabled={isDateEnabled}
        value={value}
        onIonChange={(e) => {
          return onChange(e.detail.value);
        }}
        onBlur={onBlur}
        readonly={disabled}
        type={type}
        presentation={presentation}
        style={{ direction: "ltr" }}
        locale="he-IL"
        inputRef={ref}
        name={name}
        ref={customDatetime}
        max="2032-05-31T23:59:59"
      >
        <div slot="time-label">
          {intl.formatMessage({
            id: "app.mobile.forms.time",
          })}
        </div>

        <IonButtons slot="buttons">
          <IonButton onClick={() => handleDismiss()}>
            {intl.formatMessage({
              id: "app.mobile.actions.cancel",
            })}
          </IonButton>
          <IonButton
            fill="solid"
            size="large"
            onClick={() => {
              confirm();
            }}
          >
            {intl.formatMessage({
              id: "app.mobile.actions.approve",
            })}
          </IonButton>
        </IonButtons>
      </IonDatetime>
    </IonContent>,

    {
      onDismiss: handleDismiss,
    }
  );
  return loading ? (
    <IonItem>
      <SkeltonItemContent />
    </IonItem>
  ) : (
    <IonItem>
      <IonLabel position="floating">{label}</IonLabel>
      <Controller
        rules={rules}
        control={control}
        render={({ field }) => {
          const { onChange, onBlur, value } = field;
          return (
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "100%" }}>
                <IonInput
                  value={
                    value &&
                    moment(value).format(
                      presentation && presentation === "date"
                        ? "DD/MM/YYYY"
                        : "DD/MM/YYYY  HH:mm"
                    )
                  }
                  // onIonChange={(e) => onChange(e.detail.value)}
                  onBlur={onBlur}
                  disabled={disabled}
                  type={type}
                  onClick={() => {
                    present({
                      backdropDismiss: true,
                      showBackdrop: true,
                      cssClass: "date-time-picker-modal",
                    });
                  }}
                />
              </div>
              {extraDetail && (
                <div>
                  <IonInput
                    value={extraDetail}
                    color={extraDetailColor ? extraDetailColor : "undefined"}
                    style={{ textAlign: "end" }}
                    onBlur={onBlur}
                    disabled={disabled}
                    type={type}
                    onClick={() => {
                      present({
                        backdropDismiss: true,
                        showBackdrop: true,
                        cssClass: "date-time-picker-modal",
                      });
                    }}
                  />
                </div>
              )}
            </div>
          );
        }}
        name={name}
      />
    </IonItem>
  );
};

export default DateTimePicker;
